import { createFormState } from "redux-freeform";
import { ReduxFreeformField } from "../../types";

export type TerminalsTableConfig = {
  [key: string]: ReduxFreeformField;
};

export const terminalsTableConfig: TerminalsTableConfig = {
  location_id: {
    defaultValue: "",
    validators: [],
  },
};

export const {
  reducer: terminalsTableReducer,
  mapStateToProps: terminalsTableMapStateToProps,
  mapDispatchToProps: terminalsTableMapDispatchToProps,
} = createFormState(terminalsTableConfig);
